/**
 * @file PaddleHub banner文字卡片
 * @author FengGuang(fengguang01@baidu.com)
 */
import React, {FC} from 'react';
import {Col, Row} from 'antd';

import {IBannerTextCardGroupProps} from './types';
import BannerTextCard from './BannerTextCard';

const BannerTextCardGroup: FC<IBannerTextCardGroupProps> = (props) => {
    const {list} = props;

    return (
        <div className="paddle-banner-text-card-group">
            <Row gutter={24}>
                {list.map((item) => (
                    <Col span={8} key={item.title} className="paddle-banner-text-card-wrap">
                        <BannerTextCard {...item} />
                    </Col>
                ))}
            </Row>
        </div>
    );
};

export default BannerTextCardGroup;
